import { render, staticRenderFns } from "./FaceCover.vue?vue&type=template&id=71f53f04&scoped=true"
import script from "./FaceCover.vue?vue&type=script&lang=js"
export * from "./FaceCover.vue?vue&type=script&lang=js"
import style0 from "./FaceCover.vue?vue&type=style&index=0&id=71f53f04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f53f04",
  null
  
)

export default component.exports